import { SaleGetAllByClientYardQuery } from '../../types';
import { Chip, FlagIcon, Typography } from '../../design-system';
import { CardBase, CardInfo, ContainerPhoto, AddressTypography, ChipButton } from '../dashboard';
import { formatContainerType } from '../../utils';
import { ContainerConditionToChipLabels } from '../../const';
import { i18n } from '../../i18n';

interface CardProps {
  handleClickImage: any;
  handleDotsOptionSelect: any;
  isCardImageClick?: any;
}

export const Card = ({
  handleClickImage,
  handleDotsOptionSelect,
  isCardImageClick,
  ...container
}: CardProps & SaleGetAllByClientYardQuery['data'][number]) => {
  return (
    <CardBase
      onClick={
        isCardImageClick &&
        ((e) => {
          e.stopPropagation();
          handleClickImage(container.images, container.id);
        })
      }
    >
      <ContainerPhoto
        src={container.images[0].url}
        onClick={(e) => {
          e.stopPropagation();
          handleClickImage(container.images, container.id);
        }}
      />
      <CardInfo>
        <Typography variant={'textS'}>{container.number}</Typography>
        <Typography variant={'textS'} weight={'bold'}>
          {container.sale.finalPrice}$
        </Typography>
      </CardInfo>
      <CardInfo column={'max-content max-content'}>
        <Chip size={'small'} label={formatContainerType(container.type)} color={'borderless'} />
        {container.condition && (
          <Chip
            size={'small'}
            label={ContainerConditionToChipLabels[container.condition]}
            color={'borderless'}
          />
        )}
      </CardInfo>
      <CardInfo>
        <AddressTypography variant={'textS'}>
          <FlagIcon country={container.clientYard.yard.address.country} />
          {container.clientYard.yard.address.city}
        </AddressTypography>
        {!container.isMyContainer && (
          <ChipButton
            size={'medium'}
            label={i18n.t('button.buy')}
            color={'blue'}
            onClick={(e) => {
              e.stopPropagation();
              handleDotsOptionSelect(container, container.number, 'buy', container.id);
            }}
          />
        )}
      </CardInfo>
    </CardBase>
  );
};
